export default __webpack_public_path__ + "static/media/location.8eb4c302.png";